import React, { useState } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import ReportWidgetCard from './ReportWidgetCard';
import ScheduleDemo from './ScheduleDemo';
import ShareReportModal from '../components/modals/ShareReportModal';

const successMessage = {
  create: 'Your report has been emailed. Check your inbox!',
  update: 'Your updated report has been emailed. Check your inbox!',
};

const SuccessStep = ({
  action = 'create',
  shareUrl,
  requestUrl,
  onReset,
}) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const shareReportEnabled = Boolean(shareUrl) && Boolean(requestUrl);

  return (
    <ReportWidgetCard className={cx('success-step', `success-${action}`)}>
      <div className="success-step__content">
        <div className="success-step__image" />

        <p className="success-step__text">{successMessage[action]}</p>

        <span onClick={onReset} className="btn-underline">
          Create Another Report
        </span>
        {shareReportEnabled && (
          <span onClick={() => setShowShareModal(true)} className="btn-underline">
            Share Report
          </span>
        )}
      </div>
      <ScheduleDemo
        title="See how Apptopia can fuel your business."
        className="success-step__demo"
      />

      {shareReportEnabled && (
        <ShareReportModal
          show={showShareModal}
          shareUrl={shareUrl}
          requestUrl={requestUrl}
          onHide={setShowShareModal}
        />
      )}
    </ReportWidgetCard>
  );
};

SuccessStep.propTypes = {
  action: T.oneOf(['create', 'update']),
  shareUrl: T.string,
  requestUrl: T.string,
  onReset: T.func.isRequired,
};

export default SuccessStep;
